export const slides = [
  // 🌊 Aquaculture Division (Videos)
  {
    category: "1",
    image: "/img/testimonials_1.png",
    video: "https://youtu.be/3-T1ZU4fLyI?si=eiIXushU6Iw_fPPq",
  },
  {
    category: "1",
    image: "/img/testimonials_2.png",
    video: "https://youtu.be/cuR4Fxx58zA?si=CkbaNebYlg6Yq4NI",
  },
  {
    category: "1",
    image: "/img/testimonials_3.png",
    video: "https://youtu.be/tA3uORKO1PM?si=6tVON5m6DgBJHKrO",
  },

  // 🐓 Poultry Division (Testimonials)
  {
    category: "2",
    // image: "/img/farmer_1.jpg",
    name: "Mr. M.A. Shakeel",
    designation: "Layer Poultry Farmer, Mahabubnagar, Telangana, India",
    testimonial:
      "I have been using Intron Life Sciences products on my poultry farm since 2018, and the results have been outstanding. By regularly including <b> LACTOMAX GOLD® – FS </b> in the feed, I’ve noticed excellent bird health, superior egg quality, and consistently dry litter and droppings. <br/> I also use <b>RAPIGROW®</b> from 8 weeks until the birds reach peak production. With its help, I achieve uniform body weight, standard production levels, and very few pullet eggs. From 23 weeks onwards, I consistently get 52-gram eggs, and the flock remains healthy overall.Additionally, Digimate Enzyme has helped reduce feed consumption per egg (1.09 gm/bird/day), while <b>SeE BIO®</b> as an immuno-modulator supports faster recovery during viral outbreaks. Thanks to Intron Life Sciences, I now experience higher productivity with minimal mortality. I am extremely satisfied with their products and strongly recommend them to fellow poultry farmers. <br/> Based on my experience, I confidently rate Intron Life Sciences products 5 stars ⭐⭐⭐⭐⭐.",
  },
  {
    category: "2",
    // image: "/img/farmer_2.jpg",
    name: "Mr. Rajesh Babu",
    designation: "Proprietor, Krishna Farms, Mysuru",
    testimonial:
      "I have been using <b> LACTOMAX GOLD® – FS </b> and <b> LACTOMAX GOLD® – WS </b> from Intron Life Sciences for many years, and I am extremely satisfied with the results. <br/> These products have consistently supported excellent gut health in my birds, leading to improved productivity and overall flock performance. Over time, I have seen remarkable consistency in results, which has strengthened my trust in Intron products. I truly value the reliability and effectiveness they bring to my farm operations. I highly recommend Lactomax Gold to all poultry farmers who are looking for proven solutions for bird health and superior performance."
  },
  {
    category: "2",
    // image: "/img/farmer_2.jpg",
    name: "",
    designation: "Broiler Farmer — Nagpur",
    testimonial:
      "I have been regularly using Intron’s <b> Lactomax Gold </b>, and the results have been remarkable. After introducing it to my flock, overall performance improved and digestion-related issues nearly disappeared. <br/> I always keep Lactomax Gold handy, and it has noticeably reduced the need for antibiotics in minor health cases.The product has helped me maintain healthier birds, better growth rates, and improved profitability. I strongly recommend Lactomax Gold to other poultry farmers looking for a reliable solution for gut health and productivity."
  },
  {
    category: "2",
    // image: "/img/farmer_2.jpg",
    name: "Mr. Ashok Kumar",
    designation: "Proprietor – Maa Integrators, Doddaballapura, Bengaluru(Broiler Breeding Farm)",
    testimonial:
      "We have been regularly using Intron products such as <b>Intramin OL-P, Ovopt, and Lactomax Gold FS </b> on our farm, and the results have been consistently impressive.<br/> These products have supported better flock performance, improved health, and overall productivity. We are very satisfied with the quality and effectiveness of Intron’s solutions and truly trust their products for our operations."
  },
  

];
